import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {withStyles} from '@material-ui/core/styles';
import Close from 'react-icons/lib/io/close';
import {FormattedMessage} from 'react-intl';
import {disabledDark, typoLight} from '../../themes/colors';
import BaseButton from '../button/BaseButton';
import DialogWrapper from './Dialog';
import './dialog.scss';
import {isMobile} from '../../utils/screenUtility';

const styles = () => ({
    root: {
        zIndex: 4500
    },
    paper: {
        margin: '16px',
        borderRadius: '16px',
        overflow: 'hidden',
        background: 'none'
    }
});

const cancelRender = (cancel, onDismiss) => {
    return <BaseButton className="note-dialog-btn cancel default" label={cancel} onClick={() => onDismiss()}/>;
};
const doneRender = (done, onSubmit, isDisable, isConnectedStudent, icon) => {
    return <BaseButton disabled={isDisable}
                       icon={icon}
                       className={`note-dialog-btn done ${isConnectedStudent === false ? 'btn-outline top-offset' : ''}`} label={done}
                       onClick={onSubmit}/>;
};


const BaseConfirmationDialog = ({contentSlot = null, classes, onDismiss, onSubmit, open, text, className, buttonText, cancelButtonText, onOutsideClick, isCancel = true, buttonDisabled, isConnectedStudent, preventClickOutside = false, withClose = true, withConfirm = true, doneIcon = false}) => {
    const handleClose = () => (onOutsideClick ? onOutsideClick() : onDismiss());

    return <DialogWrapper classes={{paper: classes.paper, root: classes.root}} open={open} onClose={!preventClickOutside ? handleClose : null}>
        <div className={`publish-confirmation-inner ${className || ''}`}>
            {withClose && <button className="close-confirmation-dialog" data-testid="close-dialog" onClick={handleClose}>
                <Close style={{fontSize: 21, fill: isMobile() ? disabledDark : typoLight}}/>
            </button>}
            <div className="publish-confirmation-main">
                {!contentSlot && <div>
                    <h2 className="publish-confirmation-header"><FormattedMessage id={text.question} values={{name: text.itemName}}/></h2>
                    <div className="publish-confirmation-text">
                        {text.message && <p><FormattedMessage id={text.message} values={{name: text.itemName}}/></p>}
                        {text.messageElement && text.messageElement}
                    </div>
                </div>}
                {contentSlot}
                <div className="flexbox flex-space-between buttons-wrap full-width">
                    {isCancel && <FormattedMessage id={`general.${cancelButtonText || 'cancel'}`}>
                        {cancel => cancelRender(cancel, onDismiss)}
                    </FormattedMessage>}
                    {!isCancel && <div></div>}
                    {withConfirm && <FormattedMessage id={`general.${buttonText || 'done'}`}>
                        {done => doneRender(done, onSubmit, buttonDisabled, isConnectedStudent, doneIcon)}
                    </FormattedMessage>}
                </div>
            </div>
        </div>
    </DialogWrapper>;
};

BaseConfirmationDialog.propTypes = {
    onDismiss: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    open: PropTypes.bool,
    buttonDisabled: PropTypes.bool,
    text: PropTypes.object,
    windowIcon: PropTypes.string,
};

export default withStyles(styles)(observer(BaseConfirmationDialog));
